import { CreateMediaInputApiModel } from "@app/store/http/models/input";
import { LandingPageButtonInputApiModel } from "./landing-page-button-input.api-model";

export interface UpdateLandingPageInputApiModel {
    title?: string;
    person?: string;
    slogan?: string;
    query_objects?:any
    buttons?: LandingPageButtonInputApiModel[];
    header_image?: CreateMediaInputApiModel;
    avatar_image?: CreateMediaInputApiModel;
    is_board_visible?:boolean;
    show_submit_story_btn?:any;
    enable_overlay?: boolean;
    is_footnote_visible?:boolean;
    cta?:any;
}